/**
 * Brand Carousel - Glider.js implementation with fractional slides.
 * Mirrors carousel-images-offpage (arrows only, no dots).
 */

(function () {
	'use strict';

	// Initialize carousel
	function initCarousel($block) {
		const blockElement = $block || document;
		const carousels = blockElement.querySelectorAll('.brand-carousel .glider');

		carousels.forEach(function (carousel) {
			// Skip already-initialized carousels
			if (carousel.classList.contains('glider-initialized')) return;

			const carouselId = carousel.id;
			const prevBtn = blockElement.querySelector('.btn-carousel-prev[data-carousel="' + carouselId + '"]');
			const nextBtn = blockElement.querySelector('.btn-carousel-next[data-carousel="' + carouselId + '"]');

			// Mark as initialized
			carousel.classList.add('glider-initialized');

			// Build Glider options
			const baseSlides = parseInt(carousel.getAttribute('data-slides-to-show')) || 1;
			const gliderOptions = {
				slidesToShow: baseSlides + 0.2,
				slidesToScroll: 1,
				draggable: true,
				scrollLock: true,
				responsive: [
					{
						breakpoint: 0,
						settings: { slidesToShow: 2.2 }
					},
					{
						breakpoint: 768,
						settings: { slidesToShow: 4.2 }
					},
					{
						breakpoint: 992,
						settings: { slidesToShow: baseSlides + 0.2 }
					}
				]
			};

			if (prevBtn && nextBtn) {
				gliderOptions.arrows = {
					prev: prevBtn,
					next: nextBtn
				};
			}

			const glider = new Glider(carousel, gliderOptions);
			carousel.gliderInstance = glider;

			// Show carousel after initialization to prevent CLS
			const gliderContain = carousel.closest('.glider-contain');
			if (gliderContain) {
				gliderContain.classList.add('glider-loaded');
			}

			// Update button states
			function updateState() {
				const currentSlide = glider.slide;
				const maxSlide = Math.max(0, glider.slides.length - Math.floor(glider.opt.slidesToShow));

				if (prevBtn) {
					prevBtn.toggleAttribute('disabled', currentSlide === 0);
					prevBtn.setAttribute('aria-disabled', currentSlide === 0 ? 'true' : 'false');
				}

				if (nextBtn) {
					nextBtn.toggleAttribute('disabled', currentSlide >= maxSlide);
					nextBtn.setAttribute('aria-disabled', currentSlide >= maxSlide ? 'true' : 'false');
				}
			}

			updateState();
			carousel.addEventListener('glider-slide-visible', updateState);
		});
	}

	// Initialize when DOM is ready (front-end)
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			if (typeof Glider !== 'undefined') {
				initCarousel();
			}
		});
	} else {
		if (typeof Glider !== 'undefined') {
			initCarousel();
		}
	}

	// Initialize in ACF block editor
	if (window.acf) {
		const hookNames = [
			'render_block_preview/type=brand-carousel',
			'render_block_preview/type=acf/brand-carousel',
			'render_block_preview'
		];

		hookNames.forEach(function (hookName) {
			window.acf.addAction(hookName, function ($block) {
				// Only process brand-carousel blocks
				if ($block && $block[0] && $block[0].querySelector('.brand-carousel')) {
					// Delay to let ACF finish replacing the block HTML
					setTimeout(function () {
						if (typeof Glider !== 'undefined') {
							initCarousel($block[0]);
						}
					}, 200);
				}
			});
		});

		// Also try initializing on DOM ready in editor
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function () {
				if (typeof Glider !== 'undefined') {
					setTimeout(function () {
						initCarousel();
					}, 500);
				}
			});
		}
	}
})();
